import apiClient from './api.service';

const TeacherService = {
  // Teachers awaiting demo-video review (each includes a presigned demo_video_url)
  getPendingTeachers() {
    return apiClient.get('/auth/admin/pending-teachers');
  },

  // Approve a teacher's account
  approveTeacher(userId) {
    return apiClient.post(`/auth/admin/approve-teacher/${userId}`);
  },

  // Reject a teacher's account with a reason (shown to the teacher)
  rejectTeacher(userId, reason) {
    return apiClient.post(`/auth/admin/reject-teacher/${userId}`, { reason });
  },
};

export default TeacherService;
